import {Component, Input} from '@angular/core';
import {AppState} from "@store/state/app.state";
import {Store} from "@ngrx/store";
import {ConfigState} from "@store/state/config.state";
import {Observable} from "rxjs";
import {take} from "rxjs/operators";

@Component({
    selector: 'iw-shop-dynamic-page-default-withdrawal',
    standalone: false,
    templateUrl: './default-withdrawal.component.html',
    styleUrls: ['./default-withdrawal.component.scss']
})

export class DefaultWithdrawalComponent {
    @Input() title: boolean = true;


    config$: Observable<ConfigState>;
    constructor(private store: Store<AppState>) {
        this.config$ = this.store.select(state => state.config);
    }


    getCompany(){
        let company: string = '';
        this.store.select(state => state.config)
            .pipe(take(1))
            .subscribe(config => {
                company = config.dealer.company+', '+config.dealer.street+', '+config.dealer.postcode+', '+config.dealer.town+', '+config.dealer.phone+', '+config.dealer.email+'';
            });
        return company;
    }
}
